import { render, staticRenderFns } from "./sealTest.vue?vue&type=template&id=7038c7a1&scoped=true"
import script from "./sealTest.vue?vue&type=script&lang=js"
export * from "./sealTest.vue?vue&type=script&lang=js"
import style0 from "./sealTest.vue?vue&type=style&index=0&id=7038c7a1&prod&scoped=true&lang=css"
import style1 from "./sealTest.vue?vue&type=style&index=1&id=7038c7a1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038c7a1",
  null
  
)

export default component.exports